import { callGetApi, callPostApi, callPutApi } from '../apiCallerProxy';
import { sharedBudgetApiFactory } from './sharedBudgetApiFactory';

export const sharedBudgetApi = sharedBudgetApiFactory({ callGetApi, callPostApi, callPutApi });
